// extracted by mini-css-extract-plugin
export default {"container":"UKmZd","image":"A12NW","title":"UzXWT"};